const dom = {};
const selectors = {
  carousel: ".product__media-list",
  thumb: ".desktop-thumb-container"
};
const cacheDom = () => {
  dom.thumbs = document.querySelectorAll(selectors.thumb);
  dom.carousel = document.querySelector(selectors.carousel);
};
const bindEvents = () => {
  dom.thumbs.forEach((thumb) => {
    thumb.addEventListener("click", async (e) => {
      const index = thumb.dataset.index;
      const flkty = await dom.carousel.flickityInstance;
      flkty.select(index);
      dom.thumbs.forEach((el) => el.classList.remove("is-selected"));
      thumb.classList.add("is-selected");
    });
  });
};
const productGallery = {
  init() {
    cacheDom();
    bindEvents();
  }
};
document.addEventListener("rebuy.add", () => {
  document.getElementById("mini-cart").open = true;
  fetch("/cart.js").then((r) => r.json()).then((cart) => {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", { bubbles: true, detail: { cart } })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true, detail: { cart } })
    );
  });
});
document.addEventListener("rebuy.ready", (event) => {
  var _a;
  const { widget } = event.detail;
  if (widget.id !== "288541") return;
  const products = (_a = widget.data) == null ? void 0 : _a.products;
  if (!(products == null ? void 0 : products.length)) return;
  function injectDescriptions() {
    const widgetEl2 = document.getElementById(`rebuy-widget-${widget.id}`);
    if (!widgetEl2) return;
    const titles = widgetEl2.querySelectorAll(".rebuy-product-title.clickable");
    titles.forEach((titleEl, index) => {
      var _a2, _b, _c, _d;
      if ((_a2 = titleEl.nextElementSibling) == null ? void 0 : _a2.classList.contains("rebuy-inline-upsell-desc")) return;
      const desc = (_d = (_c = (_b = products[index]) == null ? void 0 : _b.metafields) == null ? void 0 : _c.custom) == null ? void 0 : _d.description_for_inline_upsell;
      if (!desc) return;
      const el = document.createElement("p");
      el.className = "rebuy-inline-upsell-desc";
      el.textContent = desc;
      titleEl.insertAdjacentElement("afterend", el);
    });
  }
  const widgetEl = document.getElementById(`rebuy-widget-${widget.id}`);
  if (widgetEl) {
    injectDescriptions();
    const observer = new MutationObserver(() => {
      injectDescriptions();
    });
    observer.observe(widgetEl, { childList: true, subtree: true });
  }
});
document.addEventListener("DOMContentLoaded", () => {
});
document.addEventListener("galleryUpdated", () => {
  productGallery.init();
});
